<template>
   
      <div style="background-color: #eeeeee; border-radius: 15px;">
        
        <div class="d-flex flex-column align-center mb-5">
          <div style="display: flex; width:100%; font-size: 1.3rem !important;">
            <div class="cardTopActive" id="cardTopInput" v-on:click.prevent="this.changeViewWhat('input')">
            Eingabe
            </div>
            <div class="cardTopPassive" id="cardTopDayValues" v-on:click.prevent="this.changeViewWhat('dayValues')">
            Tagesübersicht
            </div>
          </div>
          <div class="d-flex flex-row align-center date" style="margin-top:20px;">
            <v-btn
              v-if="withArrs"
              size="x-small" class="prev" icon="mdi-less-than" variant="text"
              @click="daybefore"
              ></v-btn>

            
              <h4 class="currentDate mx-5 text-subtitle"
                @click="daySelect(currentDate)" style="width:223px;text-align: center; font-weight: normal;">
                {{ ShowDate.toLocaleDateString('de-DE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) }}
              </h4>
            
            
            <v-btn
              v-if="withArrs"
              size="x-small" class="next" icon="mdi-greater-than" variant="text"
              @click="dayafter"
              ></v-btn>
          </div>
        </div>
        <div v-if="this.viewWhat == 'dayValues'">
          <WearableData :ViewDate="ShowDate" />
        </div>
        <v-form class="d-flex flex-column justify-center mx-2 align-center"
        @submit.prevent
        v-if="this.viewWhat != 'dayValues'">
        <h4 class="align-self-start mx-3">Kategorien</h4>
        <!-- Period card -->
        <v-card class="rounded-xl my-4" flat width="358"
          :height="124">
          <div class="ma-5">
            <h3 class="pb-2 pl-2">Periode</h3>
            <v-chip-group>
              <v-chip v-for="(attribute,index) in PeriodIinput"
              :class="PeriodIinput[index] ? `period_chips_true` : `period_chips`"
              @click.native="setValue(index,PeriodIinput)"
              variant="outlined"
              >
              <span v-html="getDeName(index,PeriodI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <!-- Symptome card -->
        <v-card class="rounded-xl my-4" flat width="358"
          :height="260">
          <div class="ma-5">
            <h3 class="pb-2 pl-2">Symptome</h3>
            <v-chip-group
              multiple>
              <v-chip v-for="(attribute,index) in SympIinput"
              :class="SympIinput[index] ? `Symptome_chips_true` : `Symptome_chips`"
              @click.native="setValue(index,SympIinput)"
              variant="outlined">
              <span v-html="getDeName(index,SympI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <!-- Actvity card -->
        <v-card class="rounded-xl my-4" flat width="358"
          :height="219">
          <div class="ma-5">
            <h3 class="pb-2 pl-2">Aktivität</h3>
            <v-chip-group
              multiple
              >
              <v-chip v-for="(attribute,index) in ActivityIinput"
              :class="ActivityIinput[index] ? `activity_chips_true` : `activity_chips`"
              @click.native="setValue(index,ActivityIinput)"
              variant="outlined">
              <span v-html="getDeName(index,ActivityI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <!-- Pain Card -->
        <v-card style="margin:auto" width="358" class="rounded-xl my-4" flat >
          <div class="mt-5 ml-5 mb-5 mr-3">
            <h3 class="pb-2 pl-2">Schmerzen</h3>
            <div class="d-flex flex-row justify-space-between" style="width: 320px;">
              <span>0%</span>
              <span>100%</span>
            </div>
            <v-slider
              v-model="PainIinput['Pain']"
              :max="100"
              :step="10"
              show-ticks="always"
              :ticks="tickLabels"
              thumb-color="grey-lighten-2"
              class="font-weight-bold schmerzen"
              color="transparent"
              thumb-label
              @mouseup="saveData()"
              >
            </v-slider>
            
          </div>
        </v-card>
        <!-- Mood card -->
        <v-card class="rounded-xl my-4" flat width="358"
          :height="221">
          <div class="mt-5 ml-5 mb-5 mr-0">
            <h3 class="pb-2 pl-2">Stimmung</h3>
            <v-chip-group
              multiple
              >
              <v-chip v-for="(attribute,index) in MoodIinput"
              :class="MoodIinput[index] ? `stimmung_chips_true` : `stimmung_chips`"
              @click.native="setValue(index,MoodIinput)"
              variant="outlined">
              <span v-html="getDeName(index,MoodI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <!-- Miscellaneous card -->
        <v-card class="rounded-xl my-4" flat width="358">
          <div class="mt-5 ml-5 mb-5 mr-0">
            <h3 class="pb-2 pl-2">Sonstiges</h3>
            <v-chip-group
              multiple
              >
              <v-chip v-for="(attribute,index) in MiscellaneousIinput" 
              :class="MiscellaneousIinput[index] ? `sonstiges_chips_true` : `sonstiges_chips`"
              @click.native="setValue(index,MiscellaneousIinput)"
              variant="outlined">
              <span v-html="getDeName(index,MiscellaneousI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <!-- Temperatur Card -->
        <v-card class="rounded-xl my-4" flat width="358">
          <div class="d-flex flex-row justify-space-between mx-5 mt-5 mb-2">
            <h3 class="pb-2 pl-2">Temperatur</h3>
            <v-icon @click="clearTemperatur">mdi-trash-can-outline</v-icon>
          </div>
          <div class="d-flex flex-row justify-space-between mx-5">
              <span>35°C</span>
              <span>42°C</span>
          </div>
          <v-slider
              v-model="TemperatureIinput['Temperature']"
              :min="35"
              :max="42"
              :step="0.5"
              thumb-color="grey-lighten-2"
              class="font-weight-bold mx-5 temperatur mb-5"
              color="transparent"
              thumb-label
              @mouseup="saveData()"
              >
          </v-slider>
        </v-card>
        <!-- Sex and Libido card -->
        <v-card class="rounded-xl my-4" flat width="358"
          :height="245">
          <div class="mt-5 ml-5 mb-5 mr-0">
            <h3 class="pb-2 pl-2">Sex und Libido</h3>
            <v-chip-group
              multiple
              >
              <v-chip 
              
              v-for="(atrribute,index) in SexAndLibidoIinput"
              :class="SexAndLibidoIinput[index] ? `sx_chips_true mr-2 px-2` : `sx_chips mr-2 px-2`"
              @click.native="setValue(index,SexAndLibidoIinput)"
              variant="outlined"
              >
              <span v-html="getDeName(index,SexAndLibidoI)" @mouseup="saveData()"></span>
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
        <v-card class="rounded-xl my-4" flat width="358">
          <div class="d-flex flex-row justify-space-between mx-5 mt-5 mb-2">
            <h3 class="pb-2 pl-2">Notizen</h3>
            <v-icon @click="clearNotizen">mdi-trash-can-outline</v-icon>
          </div>
          <v-text-field
            class="mx-6"
            append-inner-icon="mdi-pencil"
            label="Eingabe Notizen"
            variant="outlined"
            v-model="NoteIinput['Note']"
            v-on:blur="saveData()"
          >
        </v-text-field>
        </v-card>
       <!-- <v-btn
        class="mt-4 mb-7 text-body-2 font-weight-bold rounded-lg"
        flat
        min-width="302px"
        height="56"
        color="orange-lighten-4"
        type="submit"
        @click.prevent="saveData"
        >
          Speichern
        </v-btn>--> 

        <v-btn
          class="mt-4 mb-7 font-weight-bold rounded-lg"
          flat
          min-width="302px"
          height="56"
          color="orange-lighten-4"
          type="submit"
          @click.prevent="deleteDayData"
        >
          Eingaben Zurücksetzen
        </v-btn>
      </v-form>
    </div>
</template>

<script>
import { ref, onMounted, toRaw, isProxy,toRef } from 'vue';
import { SingleDayTextInput } from '@/models/SingleDayTextInput';
import { getWeekDatesDatas } from '@/scripts/weekdatesdataloader' ;
import { MultipleDayBooleanInputs } from '@/models/MultipleDayBooleanInputs';
import  WearableData  from './WearableData.vue'

export default {
  components:{
    WearableData
  },
  props: {
    calDate: Date,
  },
  data() {
    return {
      dayPropertiesDialog: false,
      withArrs: true,
      //design related data
      tickLabels: {
        0: '0',
        10: '1',
        20: '2',
        30: '3',
        40: '4',
        50: '5',
        60: '6',
        70: '7',
        80: '8',
        90: '9',
        100: '10'
      },
    };
  },
  setup(props) {
    const PeriodI = new MultipleDayBooleanInputs('PeriodDay');
    const SympI = new MultipleDayBooleanInputs('SymptomData');
    const ActivityI = new MultipleDayBooleanInputs('Activity');
    const MoodI = new MultipleDayBooleanInputs('MoodData');
    const MiscellaneousI = new MultipleDayBooleanInputs('Miscellaneous');
    const SexAndLibidoI = new MultipleDayBooleanInputs('SexAndLibido');
    const NoteI = new SingleDayTextInput('DailyNoteData');
    const PainI = new SingleDayTextInput('PainData');
    const TemperatureI = new SingleDayTextInput('TemperatureData');
    

    const PeriodIinput = ref([]);
    const SympIinput = ref([]);
    const ActivityIinput = ref([]);
    const MoodIinput = ref([]);
    const MiscellaneousIinput = ref([]);
    const SexAndLibidoIinput = ref([]);
    const NoteIinput = ref({});
    const PainIinput = ref({});
    const TemperatureIinput = ref({});
    
    let currentDate = new Date();
    let CalDate = ref(props, 'calDate')
    let FromCalendarDate = toRaw(CalDate).value.calDate
    if(typeof FromCalendarDate != 'undefined'){
      currentDate = FromCalendarDate
    }

    const ShowDate = ref(currentDate);
    const showTS = ref(currentDate.getTime());
    let viewWhat = ref('input')

    onMounted(async () => {
      PeriodIinput.value = await PeriodI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
        });

      SympIinput.value = await SympI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
      });

      ActivityIinput.value = await ActivityI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
        });

      MoodIinput.value = await MoodI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
      });
      
      MiscellaneousIinput.value = await MiscellaneousI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
        });

      SexAndLibidoIinput.value = await SexAndLibidoI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
      });

      NoteIinput.value = await NoteI.getMyDayValues(ShowDate).then((res) => {
        //console.log(res)
        return res;
      });

      PainIinput.value = await PainI.getMyDayValues(ShowDate).then((res) => {
        return res;
      });

      TemperatureIinput.value = await TemperatureI.getMyDayValues(ShowDate).then((res) => {
        return res;
      })
    });

    return {
      currentDate,
      ShowDate,
      showTS,
      PeriodI,
      PeriodIinput,
      SympI,
      SympIinput,
      MoodI,
      MoodIinput,
      ActivityI,
      ActivityIinput,
      MiscellaneousI,
      MiscellaneousIinput,
      SexAndLibidoI,
      SexAndLibidoIinput,
      NoteI,
      NoteIinput,
      PainI,
      PainIinput,
      TemperatureI,
      TemperatureIinput,
      viewWhat,
      CalDate
    };
  },

  methods: {
    async deleteDayData(){
      let Note = toRaw(this.NoteIinput)
      Note.Note = "";

      let inputs = [toRaw(this.PeriodIinput),
                    toRaw(this.SympIinput),
                    toRaw(this.ActivityIinput),
                    toRaw(this.MoodIinput),
                    toRaw(this.MiscellaneousIinput),
                    toRaw(this.SexAndLibidoIinput)];
      for(var d=0;d<inputs.length;d++){
        let ConreteInput = inputs[d];
        let Entries = Object.keys(ConreteInput);
        for(var e=0;e<Entries.length;e++){
          ConreteInput[Entries[e]] = false
        }
      }   
      
      let sliderinputs = [
                    toRaw(this.PainIinput),
                    toRaw(this.TemperatureIinput)];
      for(var d=0;d<sliderinputs.length;d++){
        let ConreteInput = sliderinputs[d];
        let Entries = Object.keys(ConreteInput);
        for(var e=0;e<Entries.length;e++){
          ConreteInput[Entries[e]] = 0
        }
      }   

      this.saveData();
      const myTimeout = setTimeout(() => { this.daySelect(this.currentDate);}, 500);
      
    },

    changeViewWhat(toWhat){
      let InputEle = document.getElementById('cardTopInput');
      let valueEle = document.getElementById('cardTopDayValues');
      if(toWhat == 'dayValues'){
        
        valueEle.className = 'cardTopActive'
        InputEle.className = 'cardTopPassive'
        this.viewWhat = 'dayValues'
      }else{
        
        valueEle.className = 'cardTopPassive'
        InputEle.className = 'cardTopActive'
        this.viewWhat = 'input'
      }
    },
    getDeName(key,Concrete){
      //console.log(Concrete)
      return Concrete.getDeName(key)
    },
    setValue(index,Concrete){
      if(Concrete[index] === true){
        Concrete[index] = false
      }else{
        Concrete[index] = true
      }
      //console.log(Concrete[index])
    },

    
    saveData() {
      let valueKeys = Object.keys(toRaw(this.NoteIinput));
      let InputSend = toRaw(this.NoteIinput);
      for(var i=0; i < valueKeys.length; i++){
                    if(typeof formFieldValue != 'undefined'){
                        InputSend[valueKeys[i]] = formFieldValue;
                    }
                };
      let PainValueKeys = Object.keys(toRaw(this.PainIinput));
      let PainInputSend = toRaw(this.PainIinput);
      for(var i=0; i < PainValueKeys.length; i++){
                    if(typeof formFieldValue != 'undefined'){
                        PainInputSend[valueKeys[i]] = formFieldValue;
                    }
                };
      let TemperatureValueKeys = Object.keys(toRaw(this.TemperatureIinput));
      let TemperatureInputSend = toRaw(this.TemperatureIinput);
      for(var i=0; i < TemperatureValueKeys.length; i++){
                    if(typeof formFieldValue != 'undefined'){
                        TemperatureInputSend[valueKeys[i]] = formFieldValue;
                    }
                };

      if(isProxy(this.MiscellaneousIinput)){
      //console.log(toRaw(this.MiscellaneousIinput));
      this.PeriodI.insertOrUpdateToDate(toRaw(this.PeriodIinput),this.ShowDate);
      this.SympI.insertOrUpdateToDate(toRaw(this.SympIinput),this.ShowDate);
      this.MoodI.insertOrUpdateToDate(toRaw(this.MoodIinput),this.ShowDate);
      this.ActivityI.insertOrUpdateToDate(toRaw(this.ActivityIinput), this.ShowDate)
      this.MiscellaneousI.insertOrUpdateToDate(toRaw(this.MiscellaneousIinput),this.ShowDate);
      this.SexAndLibidoI.insertOrUpdateToDate(toRaw(this.SexAndLibidoIinput),this.ShowDate);
      this.NoteI.insertOrUpdateSingleRowToDate(InputSend, this.ShowDate);
      this.PainI.insertOrUpdateSingleRowToDate(PainInputSend, this.ShowDate);
      this.TemperatureI.insertOrUpdateSingleRowToDate(TemperatureInputSend, this.ShowDate);
      }

      
      setTimeout(() => {
        let myEvent = new Event("dataSyncFinished")
        document.dispatchEvent(myEvent)
      }, 300);
    },

    async daybefore(){
        let NewShowDate = new Date();
        NewShowDate.setTime((this.showTS - 24*60*60*1000));
        this.ShowDate = NewShowDate;
        this.showTS = NewShowDate.getTime();
        this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
        this.PeriodIinput =  await this.PeriodI.getMyDayValues(this.ShowDate);
        this.SympIinput=  await this.SympI.getMyDayValues(this.ShowDate);
        this.ActivityIinput =  await this.ActivityI.getMyDayValues(this.ShowDate);
        this.MiscellaneousIinput =  await this.MiscellaneousI.getMyDayValues(this.ShowDate);
        this.MoodIinput =  await this.MoodI.getMyDayValues(this.ShowDate);
        this.SexAndLibidoIinput =  await this.SexAndLibidoI.getMyDayValues(this.ShowDate);
        this.NoteIinput = await this.NoteI.getMyDayValues(this.ShowDate);
        this.PainIinput = await this.PainI.getMyDayValues(this.ShowDate);
        this.TemperatureIinput = await this.TemperatureI.getMyDayValues(this.ShowDate);
    },
    async dayafter(){
        let NewShowDate = new Date();
        NewShowDate.setTime((this.showTS + 24*60*60*1000));
        this.ShowDate = NewShowDate;
        this.showTS = NewShowDate.getTime();
        this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
        this.PeriodIinput =  await this.PeriodI.getMyDayValues(this.ShowDate);
        this.SympIinput=  await this.SympI.getMyDayValues(this.ShowDate);
        this.ActivityIinput =  await this.ActivityI.getMyDayValues(this.ShowDate);
        this.MiscellaneousIinput =  await this.MiscellaneousI.getMyDayValues(this.ShowDate);
        this.MoodIinput =  await this.MoodI.getMyDayValues(this.ShowDate);
        this.SexAndLibidoIinput =  await this.SexAndLibidoI.getMyDayValues(this.ShowDate);
        this.NoteIinput = await this.NoteI.getMyDayValues(this.ShowDate);
        this.PainIinput = await this.PainI.getMyDayValues(this.ShowDate);
        this.TemperatureIinput = await this.TemperatureI.getMyDayValues(this.ShowDate);
    },
    async daySelect(dayCell){
        let NewShowDate = new Date(dayCell);
        NewShowDate.setHours(12);
        NewShowDate.setMinutes(0);
        NewShowDate.setSeconds(0);
        NewShowDate.setMilliseconds(0);
        this.ShowDate = NewShowDate;
        this.showTS = NewShowDate.getTime();
        this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
        this.PeriodIinput =  await this.PeriodI.getMyDayValues(this.ShowDate);
        this.SympIinput=  await this.SympI.getMyDayValues(this.ShowDate);
        this.ActivityIinput =  await this.ActivityI.getMyDayValues(this.ShowDate);
        this.MiscellaneousIinput =  await this.MiscellaneousI.getMyDayValues(this.ShowDate);
        this.MoodIinput =  await this.MoodI.getMyDayValues(this.ShowDate);
        this.SexAndLibidoIinput =  await this.SexAndLibidoI.getMyDayValues(this.ShowDate);
        this.NoteIinput = await this.NoteI.getMyDayValues(this.ShowDate);
        this.PainIinput = await this.PainI.getMyDayValues(this.ShowDate);
        this.TemperatureIinput = await this.TemperatureI.getMyDayValues(this.ShowDate);
    },
    clearNotizen() {
      this.NoteIinput['Note'] = '';
    },
    clearTemperatur() {
      this.TemperatureIinput['Temperature']= '';
    },
    
  },
  mounted(){
            document.addEventListener("dataSyncFinished", e => {
                let selDay = document.getElementsByClassName('showday');
                if(typeof selDay != 'undefined')
                    if(typeof selDay[0] != 'undefined')
                        if(typeof selDay[0].parentElement != 'undefined')
                            if(typeof selDay[0].parentElement.parentElement.id != 'undefined')
                                this.daySelect(selDay[0].parentElement.parentElement.id)
            });
          },
};

</script>

<style>
.v-chip__overlay{
  background-color: rgba(255,255,255,0);
}
.period_chips{
  border-width: 2px !important;
  border-color: #EA4944;
  color: black;
  background: white;
}
.period_chips_true{
  border-width: 0 !important;
  background: #eb4a4580;
  color: black !important;
}
.Symptome_chips{
  border-width: 2px !important;
  border-color: #F8BD17;
  color: black;
  background: white;
}
.Symptome_chips_true{
  border-width: 0 !important;
  background: #F8BD1780;
  color: black !important;
}
.activity_chips{
  border-width: 2px !important;
  border-color: #1492ED;
  color: black;
  background: white;
}
.activity_chips_true{
  border-width: 0 !important;
  background: #1492ED80;
  color: black !important;
}
.stimmung_chips{
  border-width: 2px !important;
  border-color: #3214ED;
  color: black;
  background: white;
}
.stimmung_chips_true{
  border-width: 0 !important;
  background: #3214ED80;
  color: black !important;
}
.sonstiges_chips{
  border-width: 2px !important;
  border-color: #EA6C33;
  color: black;
  background: white;
}
.sonstiges_chips_true{
  border-width: 0 !important;
  background: #EA6C3380;
  color: black !important;
}
.sx_chips{
  border-width: 2px !important;
  border-color: #CD2BC7;
  color: black;
  background: white;
}
.sx_chips_true{
  border-width: 0 !important;
  background: #CD2BC780;
  color: black !important;
}
.schmerzen .v-slider-track{
  background: linear-gradient(90deg, #0D5107 0%, rgba(244, 224, 36, 0.785) 30.64%, #EA6C33 74.51%, #E3332D 100%);
}
.temperatur .v-slider-track{
  background: linear-gradient(90deg, #1147B1 0%, #E3332D 100%);
}

.cardTopActive{
  flex-basis: 50%; 
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center; 
  font-weight: normal;
  font-size: 16px;
  background: rgb(238, 238, 238)
}
.cardTopPassive{
  flex-basis: 50%; 
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center; 
  font-weight: normal;
  font-size: 16px;
  background: rgb(230, 230, 230)
}
</style>